import { TimedEntryPhase2CheckoutExperimentVariant } from '../constants/statsig';
import { getTimedEntryPhase2CheckoutExperimentValue } from './statsig';

export const isInfiniteCalendarExperimentEnabled = () => {
    const experimentValue = getTimedEntryPhase2CheckoutExperimentValue();
    return (
        experimentValue ===
        TimedEntryPhase2CheckoutExperimentVariant.newExperience
    );
};
